import { render, staticRenderFns } from "./ModalLoader.vue?vue&type=template&id=7ec8b3f2"
import script from "./ModalLoader.vue?vue&type=script&lang=js"
export * from "./ModalLoader.vue?vue&type=script&lang=js"
import style0 from "./ModalLoader.vue?vue&type=style&index=0&id=7ec8b3f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports